module.exports = __webpack_public_path__ + "img/conclusion1.a04a4932.svg";